import {BorderArticle} from "@/components/ui/general/BorderArticle";

import {RootDesc} from "@ui/descriptions/RootDesc";
import {H2} from "@ui/titles/H2";
import {H3} from "@ui/titles/H3";
import {useSelector} from "react-redux";

import {Accordeon} from "../components/Accordeon";
import styles from "./styles.module.scss";

export const AccordeonSection = ({title, items, total, recommendations}) => {
  const {isMobile} = useSelector((state) => state.common.settings);

  return (
    <div className={styles.accordeons_wrapper}>
      <H2>{title}</H2>

      <BorderArticle>
        <Accordeon
          mode={"savings"}
          items={items}
        />
      </BorderArticle>

      <BorderArticle style={{justifyContent: "flex-end"}}>
        <RootDesc>
          <span
            style={{
              fontSize: "23rem",
              fontWeight: "400",
              lineHeight: "120%",
              display: "block",
              padding: isMobile ? "16rem" : "24rem 40rem",
              textAlign: "right",
            }}
            dangerouslySetInnerHTML={{
              __html: total,
            }}
          />
        </RootDesc>
      </BorderArticle>

      {recommendations && (
        <article
          style={{
            gap: "24rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: isMobile ? "16rem" : "40rem",
            backgroundColor: "#05B4FF",
            borderRadius: "40rem",
          }}
        >
          <H3>
            <span
              style={{color: "#fff"}}
              dangerouslySetInnerHTML={{
                __html: recommendations.title,
              }}
            />
          </H3>

          <RootDesc>
            <span
              style={{
                color: "#fff",
                fontSize: "23rem",
                fontWeight: "400",
                lineHeight: "120%",
              }}
              dangerouslySetInnerHTML={{
                __html: recommendations.description,
              }}
            />
          </RootDesc>
        </article>
      )}
    </div>
  );
};
